// @ts-nocheck
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ComponentRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  TemplateRef,
} from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { UIKit } from '../../ui-kit';

export type ModalEventAction = 'ok' | 'cancel' | 'dismiss';

export interface ModalEvent {
  id: string;
  data?: any;
  action: ModalEventAction;
}

export interface ModalOptions {
  id?: string;
  fs?: boolean;
  nav?: boolean;
  cancel?: string;
  cancelTheme?: string;
  maxWidth?: 'xs' | 's' | 'm' | 'l' | 'xl';
  ok?: string;
  okTheme?: string;
  disableEsc: boolean;
  disableClickOut: boolean;
  disableScroll?: boolean;
  openCallback?: () => void;
  data?: any;
  parent?: ComponentRef<unknown>;
  html?: boolean;
}

@Component({
  selector: 'lib-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  exportAs: 'libModal',
})
export class ModalComponent implements OnInit, AfterViewInit {
  @Output() event: EventEmitter<ModalEvent> = new EventEmitter();

  @Input() id: string;

  @Input() template: TemplateRef<unknown>;

  @Input() message: string | SafeHtml;

  @Input()
  set options(partialOptions: Partial<ModalOptions>) {
    const options = {
      // defaults
      ...{
        fs: false,
        nav: true,
        cancel: '',
        cancelTheme: '',
        ok: 'Ok',
        okTheme: 'primary',
        disableEsc: false,
        disableClickOut: false,
        disableScroll: false,
        maxWidth: 's',
        html: false,
      },
      ...partialOptions,
    };

    this.ok = options.ok;
    this.okTheme = options.okTheme;
    this.cancel = options.cancel;
    this.cancelTheme = options.cancelTheme;
    this.toggle.nav = options.nav;
    this.toggle.disableEsc = options.disableEsc;
    this.toggle.disableClickOut = options.disableClickOut;
    this.toggle.disableScroll = options.disableScroll;
    this.toggle.fs = options.fs;
    this.maxWidth = options.maxWidth;
    this.html = options.html;

    this.data = options?.data;

    if (options?.openCallback) {
      options.openCallback();
    }
  }

  ok: string;

  okTheme: string;

  cancel: string;

  cancelTheme: string;

  maxWidth: string;

  html: boolean;

  toggle: UIKit.Dictionary<boolean> = {};

  data: any;

  @HostListener('window:keydown.esc', ['$event'])
  onEsc(event: KeyboardEvent): void {
    if (this.toggle.disableEsc) {
      return;
    }
    this.event.emit({ id: this.id, action: 'dismiss' });
  }

  constructor(private cd: ChangeDetectorRef) { }

  ngOnInit(): void { }

  ngAfterViewInit() {
    this.toggle.init = true;
    this.cd.detectChanges();
  }

  close(event: MouseEvent | TouchEvent, action: ModalEventAction): void {
    event.stopImmediatePropagation();
    this.event.emit({ id: this.id, action });
  }

  clickOut(event: MouseEvent | TouchEvent): void {
    event.stopImmediatePropagation();
    if (this.toggle.disableClickOut) {
      return;
    }
    this.event.emit({ id: this.id, action: 'dismiss' });
  }
}
